/**
 * Shared event name constants — a pub/sub event bus (see pubsub.js) is used
 * instead of components polling each other directly. Pattern adapted from
 * the Dawn lineage themes studied in docs/REFERENCE_AUDIT.md (usenada /
 * sunchlorella-global `constants.js` + `pubsub.js`).
 */
window.NantesEvents = Object.freeze({
  cartUpdate: 'cart-update',
  cartError: 'cart-error',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  variantSelectChange: 'variant-select-change',
});
